import { useEffect, useRef } from 'react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import {
  DuelText,
} from 'MonadomCoreUI';
import { useGlobalStateSelector, words } from './globalState';
import {
  otherSide,
  sideColor,
} from 'utils/utilsKom';
import { devLog } from 'dev/development';
import { buildNotificationMessage } from './utils';

// LIVE TEXT
function LiveText() {
  const state = useGlobalStateSelector(({ state }) => state);
  const urlParams = (new URL(document.location)).searchParams;
  const addressMain = urlParams.get('addressmain');
  const addressOperator = urlParams.get('addressoperator');
  const clientTime = urlParams.get('clienttime');
  const signatureVersion = urlParams.get('signatureversion');
  const connectionMatchingId = urlParams.get('connectionmatchingid');
  const signature = decodeURIComponent(urlParams.get('signature'));

  if (state.config.clientParameters.descriptionAndinstructions === undefined || Object.keys(state.registeredCard).length === 0) {
    return null;
  }


  return (
    <div className='' >
      <WebSocketInterfaceToBroadcast
        addressMain={addressMain} addressOperator={addressOperator} clientTime={clientTime} signatureVersion={signatureVersion} signature={signature} connectionMatchingId={connectionMatchingId}
      />
      <DuelText />
    </div>
  );
}

// WEBSOCKET INTERFACE TO BROADCAST
function WebSocketInterfaceToBroadcast(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const stateRef = useRef(state);

  // WebSocket の onMessage はマウント時のクロージャなので、最新の state は ref 経由で読む。
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect( () => {
    // const func = async () => {
    //   let configKeys;
    //   let config;

    //   configKeys = ['clientParameters'];
    //   config = await getConfig(dispatch, 'KnightsOfMonadom', configKeys , 'config');

    //   getRegisteredCard(state, dispatch);
    // };

    // func();

    let chunks = state.duel.chunks;
    let straightManChunks = state.duel.straightManChunks;
    let text = '';

    const websocketClient = new ReconnectingWebSocket('wss://' + process.env.REACT_APP_KOM_WEBSOCKET_DOMAIN);
    dispatch({type: 'setStateMultiLayers', keys: ['webSocketToBroadcastContainer', 'webSocket'], value: websocketClient});

    const requestBody = {
      action: 'connectToBroadcaster',
      subAction: 'connect',
      addressMain: props.addressMain,
      addressOperator: props.addressOperator,
      clientTime: props.clientTime,
      signatureVersion: props.signatureVersion,
      signature: props.signature,
      connectionMatchingId: props.connectionMatchingId,
    };

    const sendConnect = () => {
      // 再接続時も同じ署名URLで connect を送り直す。nonce は使わない。
      websocketClient.send(JSON.stringify(requestBody));
    };

    websocketClient.addEventListener('open', sendConnect);


    const onMessage = (event) => {
      const state = stateRef.current;
      let data;
      // let mySide;
      let opponentSide;
      // let propertyNameMyDeck;
      let propertyNameOpponentDeck;

      if (state.duel.basicInformation?.side === 'A') {
        // mySide = 'A';
        opponentSide = 'B';
        // propertyNameMyDeck = 'duelistADeck';
        propertyNameOpponentDeck = 'duelistBDeck';
      }
      else if (state.duel.basicInformation?.side === 'B') {
        // mySide = 'B';
        opponentSide = 'A';
        // propertyNameMyDeck = 'duelistBDeck';
        propertyNameOpponentDeck = 'duelistADeck';
      }

      devLog(event.data);

      try {
        data = JSON.parse(event.data);

        if (data.type === 'duelText') {
          const chunkRecoverd = data.body.content
          .replace(/<-KOM control code : new line->/g, '\n')
          .replace(/<-KOM-field->/, '\n<<フィールドの状況>>\n');

          devLog('chunkRecoverd', chunkRecoverd);

          chunks[data.body.count] = chunkRecoverd;
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: chunks});
        }
        else if (data.type === 'duelMessage') {
          if (data.subType === 'waitingInRoom') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', 0], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: state.config.clientParameters.descriptionAndinstructions});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'waitingInRoom'});
          }
          else if (data.subType === 'duelStandby') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'waitingToSummon'});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: 1});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', 0], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({
              type: 'setStateMultiLayers',
              keys: ['duel', 'text'],
              value: state.config.clientParameters.descriptionAndinstructions + '\n\nモナーの名の下に！\n'
            });
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'duelStandby'});
          }
          else if (data.subType === 'summonedMonster') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'summonedMonster'});
          }
          else if (data.subType === 'battleStandby') {
            text = ''; // 追加処理
            chunks = []; // 追加処理
            straightManChunks = []; // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: chunks}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: straightManChunks}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: data.body.monstersInformation});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: data.body.monstersIndex});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
          }
          else if (data.subType === 'magicPhase') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: data.body.monstersInformation});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformationRevised'], value: data.body.monstersInformationRevised});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.initiative});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', data.body.round], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'magicPhase'});

            // カードオープン
            for (const magic of data.body.magics[opponentSide]) {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'asset'], value: magic.asset});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'visibility'], value: 'open'});

              for (const [index, cost] of magic.costs.entries()) {
                if (state.registeredCard[magic.asset].costs[index].type === 'discardCards') {
                  for (const card of cost.cards) {
                    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'asset'], value: card.asset});
                    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'visibility'], value: 'open'});
                  }
                }
              }
            }

            devLog('monstersInformation', JSON.stringify(data.body.monstersInformation));

            // 魔法ナレーション
            let monsterName = {};

            // -- 同キャラ対決のとき名前に色を付ける。
            if (data.body.monstersInformation.A.asset === data.body.monstersInformation.B.asset) {
              monsterName.A = data.body.monstersInformation.A.name + '(' + sideColor('A') + ')';
              monsterName.B = data.body.monstersInformation.B.name + '(' + sideColor('B') + ')';
            }
            else {
              monsterName.A = data.body.monstersInformation.A.name;
              monsterName.B = data.body.monstersInformation.B.name;
            }

            for (const side of [data.body.initiative, otherSide(data.body.initiative)]) {
              const magic = data.body.magics[side][0];

              if (magic !== undefined) {
                text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

                if (magic.status === 'canceled') {
                  text += 'しかし打ち消された。\n';
                }
              }
            }

            if (text !== '') {
              text += '\n';
            }

            devLog('text', text);
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text});
          }
          else if (data.subType === 'battleUp') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: data.body.winner});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winningMonster'], value: data.body.winningMonster});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winningMonsterIndex'], value: data.body.winningMonsterIndex});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointA'], value: data.body.pointA});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointB'], value: data.body.pointB});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', data.body.round], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.initiative});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: data.body.imageNo});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: data.body.knightBoxEffect});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp'], value: { A: [], B: [] }});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'battleUp'});

            // タイムアウト時刻
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
            
            if (data.body.status === 'onDuel') {
              if (data.body.winner === state.duel.basicInformation.side) {
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'uncomfirmed'});
              } // draw含む。
              else {
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'waitingToSummon'});
              }

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.roundNext});

              // 負けた方はundefined
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterANextRound'], value: data.body.monsterANextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterIndexANextRound'], value: data.body.monsterIndexANextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterBNextRound'], value: data.body.monsterBNextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterIndexBNextRound'], value: data.body.monsterIndexBNextRound});

              // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'battleUp'});
            }
            else { // duelUp
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: null});

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'duelUp'});
            }
          }
          else if (data.subType === 'straightManPhase') {
            straightManChunks[0] = '\n<<つっこみ>>\n';
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: straightManChunks});
          }
          else {
          }
        }
        else if (data.type === 'straightManText') {
          const chunkRecoverd = data.body.content
          .replace(/<-KOM control code : new line->/g, '\n')

          devLog('chunkRecoverd', chunkRecoverd);

          straightManChunks[data.body.count] = chunkRecoverd;
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: straightManChunks});
        }
        // else if (data.type === 'duelRecovery') {
        //   const side = data.body.basicInformation.side;
        //   const roundOnDuel = data.body.roundOnDuel;
        //   const results = data.body.result;

        //   // 基本情報を格納

        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body.basicInformation});

        //   // その他のリカバリ情報を格納

        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.basicInformation.timeOutTime});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: roundOnDuel});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.basicInformation.maginaPoint});

        //   // ユーザーオペレーションによる状態変化を格納

        //   const monstersInformation = {
        //     A: state.registeredCard[data.body.monsterA],
        //     B: state.registeredCard[data.body.monsterB],
        //   };

        //   const monstersIndex = {
        //     A: data.body.monsterIndexA,
        //     B: data.body.monsterIndexB,
        //   };

        //   // 前回バトルの結果を確認して、actionを判定する。
        //   let action;
        //   const winner = results[roundOnDuel - 1].winner;

        //   if (winner === side) {
        //     action = 'skip';
        //   }
        //   else if (winner === otherSide(side)) {
        //     action = 'summon';
        //   }
        //   else {
        //     action = 'summon';
        //   }

        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: monstersInformation});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: monstersIndex});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'comfirmed'});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'onBattle'});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'action'], value: action});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: undefined});
        //   // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: { [side]: data.body.magics, [otherSide(side)]: [], }});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: { A: 0, B: 0, }});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: { A: undefined, B: undefined, }});
        //   dispatch({type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'visible'});
        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});

        //   // 魔法カードオープン・墓地カード反映

        //   const propertyNameOpponentDeck = `duelist${otherSide(side)}Deck`;

        //   for (const result of results) {
        //     if (result.magics !== undefined) {
        //       for (const magic of result.magics[otherSide(side)]) {
        //         dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'asset'], value: magic.asset});
        //         dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'visibility'], value: 'open'});

        //         for (const [index, cost] of magic.costs.entries()) {
        //           if (state.registeredCard[magic.asset].costs[index].type === 'discardCards') {
        //             for (const card of cost.cards) {
        //               dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'asset'], value: card.asset});
        //               dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'visibility'], value: 'open'});
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }

        //   // resultを配列で格納

        //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result'], value: results});

        //   if (data.subType === 'summonedMonster') {
        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointA'], value: data.body.basicInformation.pointA});
        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointB'], value: data.body.basicInformation.pointB});
        //   }
        //   else { // battleUpOrDuelUp
        //     // 魔法反映

        //     // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: results[roundOnDuel].monstersInformation});
        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformationRevised'], value: results[roundOnDuel].monstersInformationRevised});
        //     // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.basicInformation.initiative});
        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});

        //     // 魔法ナレーション

        //     let text = '';
        //     let monsterName = {};

        //     // -- 同キャラ対決のとき名前に色を付ける。
        //     if (data.body.monsterA === data.body.monsterB) {
        //       monsterName.A = state.registeredCard[data.body.monsterA].name + '(' + sideColor('A') + ')';
        //       monsterName.B = state.registeredCard[data.body.monsterB].name + '(' + sideColor('B') + ')';
        //     }
        //     else {
        //       monsterName.A = state.registeredCard[data.body.monsterA].name;
        //       monsterName.B = state.registeredCard[data.body.monsterB].name;
        //     }

        //     let duelistInOrder;
        //     const initiative = results[roundOnDuel - 1].initiativeNext;

        //     if (initiative === 'A' || initiative === 'B') {
        //       duelistInOrder = [initiative, otherSide(initiative)];
        //     }
        //     else { // coinToss, undefined
        //       duelistInOrder = ['A', 'B'];
        //     }

        //     for (const side of duelistInOrder) {
        //       const magic = data.body.magics[side][0];

        //       if (magic !== undefined) {
        //         text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';
        //         // text += state.duel.basicInformation.duelistUserName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

        //         if (magic.status === 'canceled') {
        //           text += 'しかし打ち消された。\n';
        //         }
        //       }
        //     }

        //     // ライブテキスト

        //     if (text !== '') {
        //       text += '\n';
        //     }

        //     text += results[roundOnDuel].liveText;

        //     // フィールドの状況

        //     text += '\n<<フィールドの状況>>\n';
        //     text += results[roundOnDuel].field;

        //     dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text});
        //   }
        // }
        else if (data.type === 'systemMessage') {
          if (data.body.status === 'closedTheRoom') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []}); // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: data.body.reason}); // timeUp, timeUpAfterDuelUp, leave, leaveAfterDuelUp
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'end'});

            if (data.body.reason === 'timeUp' || data.body.reason === 'leave') {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: data.body.winner});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'duelWinner'], value: data.body.duelWinner});
            }
            else if (data.body.reason === 'timeUpWithoutOpponentComming') {
              // handleClickEndDuel(state, dispatch, navigate); // ←　戻っちゃダメ！
            }
            else {
            }
          }
          else if (data.body.status === 'gptError') {
            // gptError または irregularPattern によるリトライのため、デュエルテキストをリセットする。
            chunks = []; // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: chunks});
            // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
          }
          else if (data.body.status === 'gptErrorInStraightMan') {
            // gptError または irregularPattern によるリトライのため、デュエルテキストをリセットする。
            straightManChunks = []; // 追加処理
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: straightManChunks});
          }
          else if (data.body.status === 'transactWriteSummonRejected') {
            // // おそらくコンフリクトしているので、リトライする。
            // if (state.duel.action === 'summon') {
            //   const requestBody = {
            //     action: 'summon',
            //     addressMain: state.active.addressMain,
            //     roomId: state.duel.basicInformation.roomId,
            //     roomSubId: state.duel.basicInformation.roomSubId,
            //     summonedMonster: state.duel.monstersInformation[state.duel.basicInformation.side].asset, 
            //     summonedMonsterIndex: state.duel.monstersIndex[state.duel.basicInformation.side],
            //     castMagics: state.duel.castMagics,
            //   };

            //   handleClickSummonMonster(state, dispatch, requestBody);
            // }
            // else if (state.duel.action === 'skip') {
            //   const message = {
            //     action: 'skip',
            //     addressMain: state.active.addressMain,
            //     roomId: state.duel.basicInformation.roomId,
            //     roomSubId: state.duel.basicInformation.roomSubId,
            //     castMagics: state.duel.castMagics,
            //   };

            //   handleClickNext(state, dispatch, message);
            // }
          }
        }
        else { // undefined エラーメッセージ
          const messages = {
            "internal server error": words.internalServerError[state.language],
            "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
            "this address is forbidden.": words.thisAddressIsForbidden[state.language],
            "out of service": words.outOfService[state.language],
            "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
            "invalid session.": words.pleaseLogin[state.language],
            "not enough points.": words.notEnoughPoints[state.language],
            "valid points do not exist.": words.notEnoughPoints[state.language],
            [`the number of cards in a deck must be between 3 and ${state.config.clientParameters.numberOfSlots.simple}.`]: words.theNumberOfCardsInADeckMustBeBetween3And7[state.language],
            [`the number of cards in a deck must be between 3 and ${state.config.clientParameters.numberOfSlots.advanced}.`]: words.theNumberOfCardsInADeckMustBeBetween3And11[state.language],
            "you can not use magic cards in simple mode.": words.youCanNotUseMagicCardsInSimpleMode[state.language],
            'gameMode or difficultyMode is unmatched.': words.youArePlayingAnotherDuelWhoseGameModeIsDifferent[state.language],
            "you are not permitted to receive the live of this address; ": words.youAreNotPermittedToReceiveTheLiveOfThisAddress[state.language],
            "signed url is expired.": words.signedUrlIsExpired[state.language],
          };

          const notificationMessage = buildNotificationMessage({
            applicationMessage: data.applicationMessage,
            applicationMessageGenerationMode: data.applicationMessageGenerationMode,
            applicationMessageParameters: data.applicationMessageParameters,
            messages,
          });

          if (notificationMessage !== undefined) {
            dispatch({ type: 'setNotification', key: 'notification', value: notificationMessage });
          }
        }
      }
      catch (error) {
        // エラー通知
        devLog('irregular WebSocket data.', error);
      }
    };

    websocketClient.addEventListener('message', onMessage);


    const onClose = (event) => {
      // // 通知
      // sendLog({
      //   action: 'notifyWithSession',
      //   addressMain: state.active.addressMain,
      //   sessionId: state.session[state.active.addressMain].sessionId,
      //   message: `WebSocket closed; ${JSON.stringify(event)}`,
      // });

      devLog('WebSocket closed by server.', JSON.stringify(event));
    };

    websocketClient.addEventListener('close', onClose);


    const onError = (event) => {
      // // 通知
      // sendLog({
      //   action: 'notifyWithSession',
      //   addressMain: state.active.addressMain,
      //   sessionId: state.session[state.active.addressMain].sessionId,
      //   message: `WebSocket error; ${JSON.stringify(event)}`,
      // });

      devLog('WebSocket error.', JSON.stringify(event));
    };

    websocketClient.addEventListener('error', onError);


    const beforeUnload = () => {
      websocketClient?.close();
      devLog('closed WebSocket.');
    }

    window.addEventListener('beforeunload', beforeUnload, true);


    return () => {
      try {
        websocketClient?.close();
        devLog('WebSocket closed');
      }
      catch (error) {
        devLog('WebSocket may already be closed.', JSON.stringify(error));
      }

      dispatch({type: 'setStateMultiLayers', keys: ['webSocketToBroadcastContainer', 'webSocket'], value: undefined});

      window.removeEventListener('beforeunload', beforeUnload, true);
    };
  }, []);


  return (
    <div>
    </div>
  );
}

export {
  LiveText,
};
